module.exports = __webpack_public_path__ + "img/APP_PHOTO.2e16fe01.png";